import WarningRoundedIcon from '@mui/icons-material/WarningRounded';

export const WarningIconMUI2 = WarningRoundedIcon;
